import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Pages } from '../../../../../types/offers';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import { selectState } from '../../../selectors';
import { setCurrentOfferPage } from '../../../store/offer';
import ElrReview from './elr';
import FreeTrialReview from './free-trial';
import IntegrationDetailsPanel from './integration-details-panel';
import Ioss from './ioss';

const ReviewOrder = () => {
  const {
    offer: { offerFlow },
  } = useSelector(selectState);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentOfferPage(Pages.ReviewOrder));
    dispatch(setProgressBarCurrentStep(stepNames.reviewOrder));
  }, []);

  switch (offerFlow) {
    case 'add-integration':
      return <IntegrationDetailsPanel />;
    case 'ioss':
      return <Ioss />;
    case 'free-trial':
      return <FreeTrialReview />;
    case 'elr':
    case 'dbna':
      return <ElrReview />;
    default:
      return null;
  }
};

export default ReviewOrder;
